import { render, staticRenderFns } from "./clientes-duplicados.vue?vue&type=template&id=6035b2e8&scoped=true"
import script from "./clientes-duplicados.vue?vue&type=script&lang=js"
export * from "./clientes-duplicados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6035b2e8",
  null
  
)

export default component.exports